import { IconClusterLayer } from "@wayz/react-gl"
import type { FC } from "react"
import { useCallback } from "react"
import { createSVGIcon, svgToDataURL } from "../../createSvg"
// ==============================================
function getIconSize(size: number) {
  return Math.min(100, size) / 100 + 1
}
interface ClusterLayerProps {
  id: string
  visible?: boolean
  data: any[]
  // 颜色
  fillColor?: string
  textColor?: string
  borderColor?: string
  // 方法
  onVillageIconClick?: (data: any) => void
}
const ClusterLayer: FC<ClusterLayerProps> = ({
  id = "",
  visible = false,
  data,
  fillColor,
  textColor,
  borderColor,
  onVillageIconClick,
}) => {
  const length = data.length ?? 0

  const onClick = useCallback(
    ({ object, objects, x, y }) => {
      // 单点
      if (objects) {
        // 取第一个点
        object = objects[0]
      }
      onVillageIconClick && onVillageIconClick(Object.assign({}, object, { x, y }))
    },
    [onVillageIconClick],
  )

  const getIcon = useCallback(
    (d) => {
      const dpr = window.devicePixelRatio
      const factor = Math.pow(
        d.properties.cluster ? d.properties.point_count : 1 / data.length,
        1 / 18,
      )
      const Hue = 180 - factor * 180
      const circleFillColor = fillColor ? fillColor : "hsla(" + Hue + ",100%,50%,0.7)"
      const circleTextColor = textColor ? textColor : "hsla(" + Hue + ",100%,20%,1)"
      const circleBorderColor = borderColor ? borderColor : "hsla(" + Hue + ",100%,40%,1)"
      const count = d.properties.cluster ? d.properties.point_count : 1
      // 宽高取整, 避免webgl加载纹理texture失败
      const width = Math.floor((count === 1 ? 64 : 100) * dpr)
      const height = width

      return {
        url: svgToDataURL(
          createSVGIcon(
            width,
            height,
            d.properties.cluster ? d.properties.point_count : 1,
            3,
            circleBorderColor,
            circleFillColor,
            circleTextColor,
          ),
        ),
        width,
        height,
      }
    },
    [data, fillColor, textColor, borderColor],
  )

  return (
    <IconClusterLayer
      id={`village-icon-cluster-layer-${id}`}
      visible={visible && length > 0}
      pickable={true}
      billboard={false}
      getPosition={(d) => [d.longitude, d.latitude]}
      data={data}
      getIcon={getIcon}
      getSize={(d) => getIconSize(d.properties.cluster ? d.properties.point_count : 1)}
      sizeScale={40}
      zIndex={9}
      onClick={onClick}
      updateTriggers={{ getIcon }}
    />
  )
}

export default ClusterLayer
